<script setup>
import { ref } from "vue";
import { storeToRefs } from "pinia";
import TabMenu from "primevue/tabmenu";

import { useCriarQuestoesStore } from "@/store/criarQuestoes";
const store = useCriarQuestoesStore();
const { fonteDadosParaQuestao } = storeToRefs(store);


const items = ref([
    { label: 'Tópico', icon: 'pi pi-tag' },
    { label: 'Texto', icon: 'pi pi-book' },
    //{ label: 'Imagem', icon: 'pi pi-image' },
    { label: 'Manual', icon: 'pi pi-pencil' }
]);
</script>

<template>
    <TabMenu :model="items" v-model:activeIndex="fonteDadosParaQuestao" />
</template>

